import { render, staticRenderFns } from "./UbahProfil.vue?vue&type=template&id=02cc275c"
import script from "./UbahProfil.vue?vue&type=script&lang=js"
export * from "./UbahProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports